import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './ContactForm.css';

const ContactForm = () => {
  const { language } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = language === 'ar' ? 'الاسم مطلوب' : 'Name is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = language === 'ar' ? 'البريد الإلكتروني مطلوب' : 'Email is required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = language === 'ar' ? 'البريد الإلكتروني غير صالح' : 'Invalid email format';
    }

    if (!formData.subject.trim()) {
      newErrors.subject = language === 'ar' ? 'الموضوع مطلوب' : 'Subject is required';
    }

    if (!formData.message.trim()) {
      newErrors.message = language === 'ar' ? 'الرسالة مطلوبة' : 'Message is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    const form = e.target;
    const formSubmitData = new FormData(form);

    try {
      await fetch('https://formsubmit.co/info@mandula.org', {
        method: 'POST',
        body: formSubmitData
      });

      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });

      alert(language === 'ar' 
        ? 'تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.' 
        : 'Your message has been sent successfully! We will contact you soon.');
    } catch (error) {
      alert(language === 'ar' 
        ? 'حدث خطأ. يرجى المحاولة مرة أخرى.' 
        : 'An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-card">
      <div className="form-header">
        <h2>{language === 'ar' ? 'اتصل بنا' : 'Contact Us'}</h2>
        <p>{language === 'ar' ? 'لديك سؤال أو استفسار؟ نحن هنا للمساعدة' : 'Have a question or inquiry? We\'re here to help'}</p>
      </div>

      <form onSubmit={handleSubmit} className="modern-form">
        <input type="hidden" name="_captcha" value="false" />
        <input type="hidden" name="_template" value="table" />

        <div className="form-field">
          <label htmlFor="name">
            {language === 'ar' ? 'الاسم الكامل' : 'Full Name'} <span className="required">*</span>
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={errors.name ? 'error' : ''}
            placeholder={language === 'ar' ? 'أدخل اسمك الكامل' : 'Enter your full name'}
          />
          {errors.name && <span className="error-text">{errors.name}</span>}
        </div>

        <div className="form-field">
          <label htmlFor="email">
            {language === 'ar' ? 'البريد الإلكتروني' : 'Email Address'} <span className="required">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={errors.email ? 'error' : ''}
            placeholder={language === 'ar' ? 'example@email.com' : 'example@email.com'}
          />
          {errors.email && <span className="error-text">{errors.email}</span>}
        </div>

        <div className="form-field">
          <label htmlFor="subject">
            {language === 'ar' ? 'الموضوع' : 'Subject'} <span className="required">*</span>
          </label>
          <input
            type="text"
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            className={errors.subject ? 'error' : ''}
            placeholder={language === 'ar' ? 'موضوع رسالتك' : 'Subject of your message'}
          />
          {errors.subject && <span className="error-text">{errors.subject}</span>}
        </div>

        <div className="form-field">
          <label htmlFor="message">
            {language === 'ar' ? 'الرسالة' : 'Message'} <span className="required">*</span>
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            className={errors.message ? 'error' : ''}
            rows="5"
            placeholder={language === 'ar' ? 'اكتب رسالتك هنا...' : 'Write your message here...'}
          ></textarea>
          {errors.message && <span className="error-text">{errors.message}</span>}
        </div>

        <button 
          type="submit" 
          className="submit-btn"
          disabled={isSubmitting}
        >
          {isSubmitting 
            ? (language === 'ar' ? 'جاري الإرسال...' : 'Sending...') 
            : (language === 'ar' ? 'إرسال الرسالة' : 'Send Message')}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
